import request from '../requestPB'
import { SERVER_DOMAIN } from '../constant'

// 获取企业微信图片url POST /public/enterpriseWechatGet
export const fetchWechatImage = () => {
  return request({
    url: `${SERVER_DOMAIN}/public/enterpriseWechatGet`,
    data: {},
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSGetEnterpriseWechatRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSGetEnterpriseWechatResponse',
    ERROR_ACTION: 'toast',
  })
}
